// AUTO-GENERATED FILE FROM .browserslistrc - DO NOT EDIT DIRECTLY
export const BROWSERSLIST_MIN_VERSIONS = {
  macOS: 1,
  macOSLegacy: 10.13,
  android: 156,
  ios: 15,
  chromeOsBuild: 14541,
} as const;
